<template>
  <div class="col-12">
    <card-loader ref="content" title="Gráfico de variedades">
      <bar-chart v-if="chartData" ref="chart" :chart-data="chartData" :options="options" :show-data-labels="true" />
    </card-loader>
  </div>
</template>

<script>
import BarChart from '../../../components/Charts/BarChart';
import CardLoader from '../../../components/Cards/CardLoader';
import ChartCampaignMixin from '@/mixins/chartCampaignMixin';
import ChartMixin from '@/mixins/chartMixin';
import { mapState } from 'vuex';

export default {
  components: {
    BarChart,
    CardLoader,
  },

  mixins: [ChartCampaignMixin, ChartMixin],
  props: {
    currentCampaign: {
      type: Number,
      required: true,
    },

    previousCampaign: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      chartData: null,
      options: null,
      action: 'setChartVariety',
    };
  },

  computed: {
    ...mapState('models/projection', {
      currentTableSearch: (state) => state.currentTableSearch,
    }),
  },

  mounted() {
    this.renderChart(this.previousCampaign, this.currentCampaign, this.currentTableSearch, this.distributorId);
  },

  methods: {
    async renderChart(previousCampaign, currentCampaign, search, distributor) {
      const { labels, data } = await this.$refs.content.resolve(
        this.$services.resource('projection_charts').variety({ previousCampaign, currentCampaign, search, distributor })
      );

      if (labels && data) {
        this.options = {
          scales: this.barChartScalesOptions,
          responsive: true,
          maintainAspectRatio: false,
          onClick: this.handleChartClick,
          plugins: {
            datalabels: this.dataLabelsOptions,
          },
        };

        this.labels = labels;
        this.datasets = [
          {
            label: this.previousCampaignLabel(),
            backgroundColor: this.colorOrange,
            data: data.previousSales,
            extraData: this.getExtraData(this.action, { order: true, previousCampaign: true }),
          },
          {
            label: this.projectionsLabel(),
            backgroundColor: this.colorBlue,
            data: data.projections,
            extraData: this.getExtraData(this.action, { projection: true, previousCampaign: false }),
          },
          {
            label: this.currentCampaignLabel(),
            backgroundColor: this.colorGreen,
            data: data.currentSales,
            extraData: this.getExtraData(this.action, { order: true, previousCampaign: false }),
          },
        ];

        this.chartData = { labels: Object.keys(labels), datasets: this.datasets };
      }
    },
  },
};
</script>
